import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/react';

const withAppProviders = (Component) => () => {
  function WrapperComponent() {
    return (
      <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StyledEngineProvider injectFirst>
            <Component />
          </StyledEngineProvider>
        </LocalizationProvider>
      </Sentry.ErrorBoundary>
    );
  }

  return WrapperComponent;
};

export default withAppProviders;
